// empty hostname is when accessing local file from browser
const IS_LOCAL_CONNECTION = ['localhost', '127.0.0.1', ''].includes(window.location.hostname)
const IS_STAGE_CONNECTION = window.location.hostname.includes('staging')
const IS_PRODUCTION_CONNECTION = !(IS_LOCAL_CONNECTION || IS_STAGE_CONNECTION)

const Env = {
  IS_LOCAL_CONNECTION,
  IS_STAGE_CONNECTION,
  IS_PRODUCTION_CONNECTION,
}
export default Env
